import React, { useState } from 'react';
import Button from 'components/Button';
import Auth from '@aws-amplify/auth';
import { ReactComponent as MFAIcon } from 'assets/heroicons/icon-mobile.svg';
import { useAuthWrapperContext } from 'toolbox/src/components/AuthWrapper/AuthWrapper';

const DisableMFAButton = ({ callbackFn }) => {
  const { refreshAuthState } = useAuthWrapperContext();
  const [loading, setLoading] = useState(false);

  const disableMFA = async () => {
    try {
      setLoading(true);
      const user = await Auth.currentAuthenticatedUser();
      //   await Auth.setPreferredMFA(user, 'SMS'); // hack to get out of situation where MFA was not fully set up
      await Auth.setPreferredMFA(user, 'NOMFA');
      refreshAuthState();
      alert('MFA has been disabled');
      callbackFn && callbackFn();
    } catch (err) {
      console.warn(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      onClick={disableMFA}
      className="mr-2 btn btn-white"
      disabled={loading}
    >
      {loading ? (
        'Disabling...'
      ) : (
        <>
          <MFAIcon className="inline w-5 h-5 mb-1 -ml-1" /> Disable MFA
        </>
      )}
    </Button>
  );
};

export default DisableMFAButton;
